exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-profile.dropdown .user-name {\r\n    color: #fff;\r\n    font-weight: 700;\r\n    border-bottom: 1px solid #63809e;\r\n    margin: 0 10px 4px;\r\n    padding-bottom: 4px;\r\n}\r\n\r\n.dropdown-menu .divider {\r\n    height: 1px;\r\n    margin: 0 10px 4px;\r\n    overflow: hidden;\r\n    background-color: #63809e;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/navmenu/navmenu.component.css
// module id = ../../../../../src/app/components/navmenu/navmenu.component.css
// module chunks = main